import gql from 'graphql-tag';

export default gql`
  query searchNewWardForStore($storeUuid: String!) {
    searchNewWardForStore(storeUuid: $storeUuid) {
      data {
        code
        fullName
        fullNameEn
        isRecommended
      }
    }
  }
`;
